module.exports = __webpack_public_path__ + "static/media/icon-arrows@2x.479d6f1c.png";